import React from 'react';
import './RichTextDisplay.css';
import { sanitizeHtml } from '../utils/sanitize';

interface RichTextDisplayProps {
  content: string;
  className?: string;
}

const RichTextDisplay: React.FC<RichTextDisplayProps> = ({ content, className = '' }) => {
  if (!content) {
    return null;
  }

  // Check if content is HTML or plain text
  const isHTML = /<[^>]*>/g.test(content);

  return (
    <div
      className={`rich-text-display ${className}`}
      dangerouslySetInnerHTML={{ __html: sanitizeHtml(isHTML ? content : `<p>${content}</p>`) }}
    />
  );
};

export default RichTextDisplay;
